export class OutboxIdempotencyConflictError extends Error {
    idempotencyKey;
    constructor(idempotencyKey) {
        super("Outbox idempotency key belongs to a different command");
        this.name = "OutboxIdempotencyConflictError";
        this.idempotencyKey = idempotencyKey;
    }
}
//# sourceMappingURL=outbox.js.map